module.exports = __webpack_public_path__ + "media/images/rewards/shopping2-2eaae68c09159af4d9e95063a2c85845.png";